import React from 'react'
import { Box, Grid, IconButton } from '@material-ui/core'
import { Typography } from '../../../../ui'
import { Cancel as CancelIcon } from '@material-ui/icons'
import { formatPrice } from '../../../../../utils'

const IngredientProductList = ({ products, onRemove, supplier }) => {
  return (
    <Grid item xs={12}>
      <Box bgcolor="background.paper" borderRadius={10} p={2}>
        <Grid container spacing={2}>
          {products && products.length > 0 ? (
            <>
              <Grid item xs={3}>
                <Typography variant="h5" color="lightGreen">
                  Product
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h5" color="lightGreen">
                  Gram Equivalient Weight
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography variant="h5" color="lightGreen">
                  Price
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography variant="h5" color="lightGreen">
                  Supplier
                </Typography>
              </Grid>
              <Grid item xs={1} />
            </>
          ) : null}
          {products && products.length > 0
            ? products.map((product, index) => (
                <React.Fragment key={index}>
                  <Grid item xs={3}>
                    <Typography>
                      {product.product.name ? product.product.name : null}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography>
                      {product.product.gramEquivalentWeight
                        ? product.product.gramEquivalentWeight
                        : 'Unknown'}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography>
                      {product.product.price
                        ? formatPrice(product.product.price)
                        : null}
                    </Typography>
                  </Grid>
                  <Grid item xs={3}>
                    <Typography>
                      {product.supplier.name ? product.supplier.name : null}
                    </Typography>
                  </Grid>
                  {onRemove ? (
                    <Grid item xs={1} container justifyContent="flex-end">
                      <IconButton
                        onClick={() => onRemove(product.product.id)}
                        size="small"
                      >
                        <CancelIcon />
                      </IconButton>
                    </Grid>
                  ) : null}
                </React.Fragment>
              ))
            : null}
          {products && products.length === 0 ? (
            <Typography variant="body1" style={{ padding: 5 }}>
              No Products Selected
            </Typography>
          ) : null}
        </Grid>
      </Box>
    </Grid>
  )
}

export default IngredientProductList
